// extracted by mini-css-extract-plugin
module.exports = {"customRow":"CustomEmailPage_customRow__2NQIv"};